<script>
import { Dashboard } from '@uppy/vue'

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'

export default {
  name: 'InlineFileUpload',
  props: ['allowMultipleUploads'],
  components: {
    Dashboard,
  },
  computed: {
    uppy(){
        const uppy = new Uppy({
          allowMultipleUploads: false,
          //autoProceed: true
          restrictions: {
             allowedFileTypes: ['image/*'],
          }
        })
        uppy.use(AwsS3, {
            companionUrl: 'https://xali-uppy-companion.herokuapp.com/'
        })
        uppy.on('upload-success', (file, response) => {
          this.$emit('file-uploaded', response.uploadURL)
          uppy.reset()
        })
        return uppy
    },
    dashboard(){
      return {
        height: 200,
        proudlyDisplayPoweredByUppy: false,

        locale: {
          strings: {
            dropPasteImport: "Drop your image here, %{browse} or import from"
          }
        }
      }
    }
  },
  beforeDestroy () {
    this.uppy.close()
  }
}
</script>

<template>
    <dashboard :uppy="uppy" :props="dashboard" />
</template>
